// extracted by mini-css-extract-plugin
export var active = "_cs-c";
export var compactArrow = "_cs-5";
export var container = "_cs-0";
export var dot = "_cs-b";
export var dotContainer = "_cs-a";
export var hoverArrowButton = "_cs-7";
export var hoverArrowContainer = "_cs-6";
export var leftHoverArrowContainer = "_cs-8 _cs-6";
export var rightHoverArrowContainer = "_cs-9 _cs-6";
export var slide = "_cs-4";
export var sliderContainer = "_cs-1";
export var sliderContainerVisibleOverflow = "_cs-2";
export var sliderOverflow = "_cs-3";
export var vignetteBoth = "_cs-f";
export var vignetteLeft = "_cs-e";
export var vignetteRight = "_cs-d";